import axiosInstance from "./axiosInstance";
const apiUrl = process.env.REACT_APP_API_URL;

/// code updated with proper error handling
export const postCategoryData = async (categories) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/save_ticket_category/`,
      categories,
    );

    return response.data;
  } catch (error) {
    let message =
      error?.response?.data?.error || // backend "error"
      error?.response?.data?.message || // backend "message"
      error?.response?.data?.detail;
    // if array → convert to string
    if (Array.isArray(message)) {
      message = message.join(", ");
    }

    throw new Error(message || "Failed to add category"); // important
  }
};
/// arwa code
export async function getCategoryData() {
  try {
    const response2 = await axiosInstance.get(
      `${apiUrl}/api/ticket_categories/`,
    );
    return response2.data;
  } catch (error) {
    throw error;
  }
}

/// komal code:
export const editCat = async (categoryId, updatedData) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/ticket_category/edit/${categoryId}/`,
    updatedData,
  );
  return response.data;
};

export const deleteCat = async (categoryId) => {
  try {
    const response = await axiosInstance.delete(
      `${apiUrl}/api/delete_ticket_category/${categoryId}/`,
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.error || // your backend message
      error?.response?.data?.message ||
      "Failed to delete category";

    throw new Error(message); // important
  }
};

/// komal code
export const fetchSubcategories = async () => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/ticket_subcategories/`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategories:", error);
  }
};

// added by shreyasi
export async function postSubCategories(subForm) {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/save_ticket_subcategory/`,
      subForm,
    );

    return response.data;
  } catch (error) {
    let message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.response?.data?.detail;

    // handle array error
    if (Array.isArray(message)) {
      message = message.join(", ");
    }

    // fallback for validation errors
    if (!message) {
      message = Object.values(error?.response?.data || {})
        ?.flat()
        ?.join(", ");
    }

    throw new Error(message || "Failed to add subcategory");
  }
}

//// maitry code
export async function getTicketSubcategory(ticketId) {
  const res = await axiosInstance.get(
    `${apiUrl}/api/get_ticket_subcategory/${ticketId}`,
  );
  return res.data;
}
export async function editSubcategory(subcategorytransid, formData) {
  try {
    const res = await axiosInstance.put(
      `${apiUrl}/api/edit_ticket_subcategory/${subcategorytransid}/`,
      formData,
    );

    return res.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong while updating subcategory";

    console.error("Edit Subcategory Error:", error);

    throw new Error(message);
  }
}

export async function deleteSubcategory(ticketId) {
  try {
    const res2 = await axiosInstance.delete(
      `${apiUrl}/api/delete_ticket_subcategory/${ticketId}/`,
    );

    return res2.data;
  } catch (error) {
    const message =
      error?.response?.data?.error || // backend error
      error?.response?.data?.message ||
      "Failed to delete subcategory";

    throw new Error(message); // important
  }
}

//// configuration tab:::
//// save details of assign email for ticket updates

export const assignEmailApi = async (data) => {
  const response = await axiosInstance.post(
    `${apiUrl}/api/create_configuration/`,
    data,
  );
  return response;
};

export const filterConfApi = async (cid) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/filter-configurations/${cid}/`,
  );
  return response;
};
export const getStatusApi = async () => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get_ticket_status/`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ticket status:", error);
    throw error;
  }
};

export const addStatusApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/save_ticket_status/`,
      data,
    );
    return response.data;
  } catch (error) {
    // console.log("Error",error?.response);
    return error?.response || { error: "Failed to add status" };
  }
};

export const editStatusApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/update_ticket_status/`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating ticket status:", error);
    throw error;
  }
};

export const deleteStatusApi = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${apiUrl}/api/delete_ticket_status/${id}/`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting ticket status:", error);

    // ✅ THROW instead of return
    throw error?.response?.data || error;
  }
};

export const getPriorityApi = async () => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/api/priorities/`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching priorities:", error);
    throw error;
  }
};

export const addPriorityApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/priorities/create/`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error adding priority:", error);
    throw error;
  }
};

export const editPriorityApi = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `${apiUrl}/api/priorities/update/${id}/`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating priority:", error);
    throw error;
  }
};

export const deletePriorityApi = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${apiUrl}/api/priorities/delete/${id}/`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting priority:", error);
    throw error;
  }
};

export const getAllStatus = async () => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/get-all-ticket-status/`,
    );

    if (response?.data?.data) {
      return response.data.data; // return only status array
    } else {
      console.warn("Unexpected response format:", response.data);
      return [];
    }
  } catch (error) {
    if (error.response) {
      // Server responded with error
      console.error(
        "Server Error:",
        error.response.data?.message || error.response.statusText,
      );
    } else if (error.request) {
      // No response received
      console.error("No response from server:", error.request);
    } else {
      // Other errors
      console.error("Error:", error.message);
    }

    return [];
  }
};
